import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { checkEmailCompare } from '@store/actions/eaAction';
import { showModal } from '@store/actions/commonAction';
import { toPhone } from '@common/utils/validation';

import ChangeCustomerEmail from '@components/ea/ChangeCustomerEmail';
import SatInput from '@components/common/satUI/SatInput';
import SatModal from '@components/common/satUI/SatModal';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatButton from '@components/common/satUI/SatButton';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';

import PostCodeSearchPopup from '@components/common/biz/PostCodeSearchPopup';

const ContactInfo = props => {
  const {
    custNo,
    emailAddr,
    mobileTelNo,
    homeTelNo,
    wkplTelNo,
    postRcvTpCd,
    homeAddr,
    homeAddrDtl,
    homeZipCd,
    wkplAddr,
    wkplAddrDtl,
    wkplZipCd,
    isShowError,
    onCheck,
    onChange,
  } = props;

  const dispatch = useDispatch();
  const emailInputRef = useRef();
  const homeAddrRef = useRef();
  const wkplAddrRef = useRef();
  const [inputEmailVisible, setInputEmailVisible] = useState(false);
  const [homeAddrInfo, setHomeAddrInfo] = useState(false);
  const [wkplAddrInfo, setWkplAddrInfo] = useState(false);
  const [searchAddrVisible, setSearchAddrVisible] = useState(false);
  const [addressType, setAddressType] = useState('1'); // 1: 자택 , 2: 직장
  const [emailError, setEmailError] = useState(false);

  useEffect(() => {
    let homeAddrTxt = '';
    let wkplAddrTxt = '';

    // 자택주소
    if (homeZipCd) {
      homeAddrTxt = `(${homeZipCd}) `;
    }
    if (homeAddr) {
      homeAddrTxt += homeAddr;
    }
    if (homeAddrDtl) {
      homeAddrTxt += ` ${homeAddrDtl}`;
    }

    // 회사주소
    if (wkplZipCd) {
      wkplAddrTxt = `(${wkplZipCd}) `;
    }
    if (wkplAddr) {
      wkplAddrTxt += wkplAddr;
    }
    if (wkplAddrDtl) {
      wkplAddrTxt += ` ${wkplAddrDtl}`;
    }

    setHomeAddrInfo(homeAddrTxt);
    setWkplAddrInfo(wkplAddrTxt);
  }, [homeAddr, wkplAddr, homeZipCd, wkplZipCd, homeAddrDtl, wkplAddrDtl]);

  const handleCheckBox = (type, isChecked) => {
    if (isChecked) onCheck({ postRcvTpCd: type });
    else onCheck({ postRcvTpCd: '' });
  };

  const handleInputHomeTelNo = value => {
    onChange({ homeTelNo: toPhone(value) });
  };

  const handleInputWkplTelNo = value => {
    onChange({ wkplTelNo: toPhone(value) });
  };

  const handleInputEmailAddr = value => {
    setInputEmailVisible(false);
    emailInputRef.current.onBlur();

    // hanjy: 이메일 유효성 검증 기능이 백엔드에 미구현되어 주석처리
    // dispatch(
    //   checkEmailCompare({
    //     email: value,
    //     custNo: custNo,
    //     callback: callbackCheckEmailSuccess,
    //   }),
    // );
    onChange({ emailAddr: value });
  };

  const callbackCheckEmailSuccess = data => {
    if (data.lpGaContract) {
      // LP/FP 본인 청약일때는 이메일 검증 하지 않음
      onChange({ emailAddr: data.email });
    } else {
      if (data.checkEmailAllYn) {
        // 이메일주소 전체가 동일한 경우
        onChange({ emailAddr: '' });
        setEmailError(true);
        dispatch(
          showModal({
            visible: true,
            type: 'info',
            msg: `계약자의 이메일 주소와 담당 보험설계사의 이메일 주소(${data.email})가 동일해요. 이메일 주소를 다시 입력해주세요.`,
          }),
        );
      } else if (data.checkEmailIdYn) {
        // 이메일주소 앞부분이 동일한 경우
        dispatch(
          showModal({
            visible: true,
            type: 'confirm',
            msg: `계약자의 이메일 주소 ID와 담당 보험설계사의 이메일 주소 ID(${
              data.email.split('@')[0]
            })가 동일해요. 진행하시겠어요?`,
            onOk: {
              label: '예',
              handle: () => {
                onChange({ emailAddr: data.email });
                emailError && setEmailError(false);
              },
            },
            onCancel: {
              label: '아니오',
              handle: () => {
                onChange({ emailAddr: '' });
                setEmailError(true);
              },
            },
          }),
        );
      } else {
        onChange({ emailAddr: data.email });
        emailError && setEmailError(false);
      }
    }
  };

  const handleOnClickAddr = value => {
    if (value === '1') {
      homeAddrRef.current.onBlur();
    } else {
      wkplAddrRef.current.onBlur();
    }
    setAddressType(value);
    setSearchAddrVisible(true);
  };

  // 주소 검색 결과 저장
  const handleInputAddress = value => {
    console.log('### 카카오 주소검색 api response => ', value);

    let addrData;
    if (addressType === '1') {
      // 자택
      addrData = {
        homeAddr: value.address,
        homeAddrDtl: value.detailAddress,
        homeZipCd: value.zoneCode,
        homeAddrType: value.userSelectedType,
      };
    } else {
      // 직장
      addrData = {
        wkplAddr: value.address,
        wkplAddrDtl: value.detailAddress,
        wkplZipCd: value.zoneCode,
        wkplAddrType: value.userSelectedType,
      };
    }
    onChange(addrData);
  };

  // 주소 삭제 버튼
  const handleDeleteAddress = type => {
    let addrData;
    if (type === '1') {
      // 자택
      addrData = {
        homeAddr: '',
        homeAddrDtl: '',
        homeZipCd: '',
      };
    } else {
      // 직장
      addrData = {
        wkplAddr: '',
        wkplAddrDtl: '',
        wkplZipCd: '',
      };
    }
    onChange(addrData);
  };

  return (
    <React.Fragment>
      <h2 className="tit-con">연락처</h2>
      <div className="box two">
        <SatInput
          value={mobileTelNo === null ? '' : mobileTelNo}
          type="text"
          label="휴대전화번호"
          readOnly
          bold
        />
        <SatInput
          ref={emailInputRef}
          value={emailAddr}
          focusLabel="이메일"
          label="이메일"
          onClick={() => setInputEmailVisible(true)}
          suffix={() => (
            <SatButton
              styleClass={`ico ico-edit`}
              onClick={() => setInputEmailVisible(true)}
            />
          )}
          customStyleClass={emailError ? 'error' : ''}
        />
      </div>

      <div className="box two">
        <SatInput
          value={homeTelNo === null ? '' : homeTelNo}
          type="number"
          label="자택전화번호"
          onChange={handleInputHomeTelNo}
          bold
        />

        <SatInput
          value={wkplTelNo === null ? '' : wkplTelNo}
          type="number"
          label="회사전화번호"
          onChange={handleInputWkplTelNo}
          bold
        />
      </div>
      <h2 className="tit-con">우편물수령처</h2>
      <SatValidationErrMsg
        visible={isShowError && postRcvTpCd === ''}
        type="error"
        message="우편물수령처를 지정해주세요."
      />
      <div className="box two">
        <SatCheckBox
          value={[postRcvTpCd === '1' ? true : false]}
          options={[{ label: '자택', value: '1' }]}
          onChange={value => handleCheckBox('1', value)}
        />
        <SatInput
          ref={homeAddrRef}
          value={homeAddrInfo}
          label={'자택주소'}
          suffix={() => (
            <SatButton
              styleClass={`ico ico-search`}
              onClick={() => handleOnClickAddr('1')}
            />
          )}
          customStyleClass={
            isShowError && postRcvTpCd === '1' && homeAddrInfo === ''
              ? 'error'
              : ''
          }
          onClick={() => handleOnClickAddr('1')}
        />
        <span className="txt-del" onClick={() => handleDeleteAddress('1')}>
          삭제
        </span>
      </div>
      <SatValidationErrMsg
        visible={isShowError && postRcvTpCd === '1' && homeAddrInfo === ''}
        type="error"
        message="주소를 입력해주세요."
      />
      <div className="box two">
        <SatCheckBox
          value={[postRcvTpCd === '2' ? true : false]}
          options={[{ label: '직장', value: '2' }]}
          onChange={value => handleCheckBox('2', value)}
        />
        <SatInput
          ref={wkplAddrRef}
          value={wkplAddrInfo}
          label={'회사주소'}
          suffix={() => (
            <SatButton
              styleClass={`ico ico-search`}
              onClick={() => handleOnClickAddr('2')}
            />
          )}
          customStyleClass={
            isShowError && postRcvTpCd === '2' && wkplAddrInfo === ''
              ? 'error'
              : ''
          }
          onClick={() => handleOnClickAddr('2')}
        />
        <span className="txt-del" onClick={() => handleDeleteAddress('2')}>
          삭제
        </span>
      </div>
      <SatValidationErrMsg
        visible={isShowError && postRcvTpCd === '2' && wkplAddrInfo === ''}
        type="error"
        message="주소를 입력해주세요."
      />
      <SatModal
        visible={inputEmailVisible}
        type="info"
        title="이메일 변경"
        setVisible={() => {
          setInputEmailVisible(false);
          emailInputRef.current.onBlur();
        }}
        wide
      >
        <ChangeCustomerEmail
          emailAddr={emailAddr}
          onChange={handleInputEmailAddr}
        />
      </SatModal>
      <PostCodeSearchPopup
        visible={searchAddrVisible}
        setVisible={() => setSearchAddrVisible(false)}
        onCompleteAddress={address => handleInputAddress(address)}
      />
    </React.Fragment>
  );
};

export default ContactInfo;
